import React from "react";
import { Button, Modal } from "@telia/teddy";

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void | Promise<void>;
}

const ExistingSubscriptionDiscardModal: React.FC<Props> = ({ open, onClose, onConfirm }) => (
    <Modal open={open} onOpenChange={onClose}>
        <Modal.Overlay>
            <Modal.Content size="sm">
                <Modal.Group variant="title">
                    <Modal.Title as="h3" mt="600">
                        Du må fullføre hele flyten for å endre det eksisterende abonnementet
                    </Modal.Title>
                    <Modal.Close aria-label="lukk" slot="floating" onClick={onClose} />
                </Modal.Group>
                Vil du forkaste endringene på abonnementet?
                <Modal.Group variant="action">
                    <Modal.Close slot="content">
                        <Button variant="secondary" onClick={onClose}>
                            Avbryt
                        </Button>
                    </Modal.Close>
                    <Button variant="destructive" onClick={onConfirm}>
                        Forkast endringene
                    </Button>
                </Modal.Group>
            </Modal.Content>
        </Modal.Overlay>
    </Modal>
);

export default ExistingSubscriptionDiscardModal;
